import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ArrayHelper } from 'src/app/helpers';

export type CardItem = {
  name: string;
  added?: boolean;
  editing?: boolean;
};

@Component({
  selector: 'app-page-activity-card-item',
  templateUrl: './page-activity-card-item.component.html',
  styleUrls: ['./page-activity-card-item.component.css']
})
export class PageActivityCardItemComponent implements OnInit {

  @Input()
  public pool!: CardItem[];

  @Input()
  public item!: CardItem;

  constructor() { }

  ngOnInit(): void {
  }

  editCard(item: CardItem) {
    if (item.added && !item.editing) {
      item.editing = true;
    }
  }

  saveCard(item: CardItem) {
    if (item.added && item.editing) {
      item.name = item.name.trim();
      item.editing = false;
    }
  }

  deleteCard(item: CardItem) {
    if (item.added && (item.name ? confirm('Are you sure to delete card?') : true)) {
      ArrayHelper.removeItem(this.pool, item);
    }
  }
}
